const VENDOR_ID_SESSION = 'sss:vendorId';

export default VENDOR_ID_SESSION;
